module.exports = __webpack_public_path__ + "img/exchange-success.16eded1b.svg";